import { create } from "zustand";

export interface CompanyDto {
  id: number;
  admin_ids: number[];
  name: string;
  logo: string | null;
  description: string | null;
  inn: string;
  address: string | null;
  director: string | null;
  telephone: string | null;
  email: string | null;
  status: "pending" | "approved" | "rejected" | "in_progress";
  instance_ids: number[];
  role: "admin" | "member";
  created_at: string;
  updated_at: string;
}

export interface CompaniesState {
  companies: CompanyDto[];
  loading: boolean;
  error: string | null;
  /** true after the first successful API load — prevents duplicate GETs on navigation. */
  hasLoaded: boolean;
}

interface CompaniesActions {
  setCompanies: (companies: CompanyDto[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearCompanies: () => void;
}

const initialState: CompaniesState = {
  companies: [],
  loading: false,
  error: null,
  hasLoaded: false,
};

export const useCompaniesStore = create<CompaniesState & CompaniesActions>()(
  (set) => ({
    ...initialState,

    setCompanies: (companies: CompanyDto[]) => {
      set({ companies, loading: false, error: null, hasLoaded: true });
    },

    setLoading: (loading: boolean) => {
      set({ loading });
    },

    setError: (error: string | null) => {
      set({ error, loading: false });
    },

    clearCompanies: () => {
      set({ ...initialState });
    },
  }),
);
